import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const benefits = ['Por fin vas a saber exactamente qué darle, sin dudas ni culpa', 'Tu perro va a empezar a mostrar cambios reales: más energía, mejor digestión, pelo sano', 'Vas a hacer el cambio sin miedo porque cada paso está explicado para que no te equivoques', 'Se acabaron las horas buscando en internet sin encontrar nada claro. Acá está todo en un solo lugar', 'Vas a sentirte segura con lo que le das y esa tranquilidad no tiene precio', 'Vas a ser la dueña que sabe cómo cuidar a su perro de verdad'];
export function TransformationSection() {
  return <section className="py-12 md:py-16 px-4 bg-cream" data-id="element-247">
      <div className="max-w-3xl mx-auto" data-id="element-248">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-249">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-charcoal mb-4 leading-tight" data-id="element-250">
            Por eso creamos <br data-id="element-251" />
            <span className="text-primary" data-id="element-252">Nutrición Canina Fácil</span>
          </h2>

          <p className="text-lg md:text-xl text-primary mb-8 font-medium max-w-xl mx-auto" data-id="element-253">
            Todo lo que necesitás para alimentar bien a tu perro, explicado
            simple, paso a paso, para que empieces hoy y nunca más dudes.
          </p>

          <div className="space-y-5 max-w-md mx-auto text-left" data-id="element-254">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-center" data-id="element-255">
                <CheckCircle2Icon className="w-6 h-6 text-primary flex-shrink-0 mr-4" data-id="element-256" />
                <span className="text-lg text-gray-800" data-id="element-257">{benefit}</span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}